export default "__VITE_ASSET__CS33VN4j__"